export class Colaborador {
  empresa: string;
  filial: string;
  tafil: string;
  matricula: string;
  senha: string;

  toUsuarioJ2(): any {
    const empresaFuncionario = this.matricula.substring(0, 2);
    const matriculaFuncionario = this.matricula.substring(2);
    return {
      empresa: this.empresa,
      filial: this.filial,
      tafil: this.tafil,
      senha: this.senha,
      funcionario: {
        empresa: empresaFuncionario,
        matricula: matriculaFuncionario
      }
    };
  }

}

